// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScanSegment_wrapper__XkUcT","title":"ScanSegment_title__PGH5B","scanner":"ScanSegment_scanner__e8eRL"};